import { CommonModule, DatePipe } from '@angular/common';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FlameCalendarComponent } from './calendar.component';
import { FlameIconModule } from '@ngx-mxflame/atoms/icon';
import { registerLocaleData } from '@angular/common';
import localeEsMX from '@angular/common/locales/es-MX';

registerLocaleData(localeEsMX, 'es-MX');

@NgModule({
  imports: [
    CommonModule,
    FlameIconModule,
  ],
  declarations: [FlameCalendarComponent],
  exports: [FlameCalendarComponent],
  providers: [DatePipe,
     { provide: LOCALE_ID, useValue: 'es-MX' }
  ],
})
export class TaFlameCalendarModule {}
